import axios                from "axios";
import Vue                  from "vue";
import {dateConvert, webRequestWrap} from "../plugins/utils";
import countries            from "./resources/countries";
import heights              from "./resources/heights";
import shoe_sizes           from "./resources/shoe_sizes";
import shoe_sizes_2ndave    from "./resources/shoe_sizes_2ndave";
import snowboard_types      from "./resources/snowboard_types";
import states               from "./resources/states";
import canadian_states               from "./resources/canadianStates";
import {normalizeResources} from "./resources/utils/resource_vuex";

import ui from "./modules/ui";
import validation from "./modules/validation";


async function prepareVuexConfig(reservationModule) {
    const {store} = reservationModule;
    const normalResources = normalizeResources({
        countries       : {value: countries},
        states          : {value: states},
        canadian_states : {value: canadian_states},
        heights         : {value: heights},
        shoe_sizes      : {value: shoe_sizes},
        shoe_sizes_2ndave      : {value: shoe_sizes_2ndave},
        snowboard_types : {value: snowboard_types},
        config          : {'__remote': true},
        policy_and_terms: {'__remote': true},
        phone_masks     : {'__remote': true},
        ...store.state.resources

    });
    return {
        state    : {
            ...store.state,
            meta         : {
                environment: ['kiosk'],
                ...(store.state.meta || {})
            },
            currentStepId: store.state.model.reservation?.meta_state?.step || store.state.steps[0].id,
            resources    : normalResources.state,
            model        : await store.state.model(),
            config       : {
                dateFormat : 'MM/DD/YYYY',
                loading    : true,
                stepLoading: false
            },
            coupon_response: '',
            coupon_status: 200,
            return_customer_full_name: "",
            return_customer_dob: "",
            is_watched_rental_details: false,
            disabled_status: false,
            book_me_host_code: '',
            do_not_show_price_on_checkout: 0,
            skip_checkout: 0,
            total_without_discount: 0,
            prepay_discount: 0,
            prepay_total_price: 0,
            prepay_sales_tax: 0,
            prepay_tax_percent: 0,
            prepay_special_fee: 0,
            single_day_type: '',
            is_in_special_period: false,
            special_period_increase: 0,
            special_period_start_date: new Date(),
            special_period_end_date: new Date(),
            special_period_rate_type: 'percent',
            focusInput: null,
            rechapcha_is_checked: false,
            prepay_total_packages_price: 0,
        },
        getters  : {
            packages_list_data(state) {
                return state.resources.package_categories.map((c) => {
                    return {
                        ...c,
                        items: state.resources.packages.filter(p => p.category_id === c.id)
                    }
                });

            },

            coupon_response(state) {
                return state.coupon_response;
            },

            coupon_status(state) {
                return state.coupon_status;
            },

            return_customer(state) {
                return {
                    full_name: state.return_customer_full_name,
                    dob: state.return_customer_dob
                };
            },
            is_watched_rental_details(state) {
                return state.is_watched_rental_details;
            },
            disabled_status(state){
                return state.disabled_status;
            },
            book_me_host_code(state){
                return state.book_me_host_code;
            },
            do_not_show_price_on_checkout(state){
                return state.do_not_show_price_on_checkout;
            },
            skip_checkout(state){
                return state.skip_checkout;
            },
            total_without_discount(state){
                return state.total_without_discount;
            },
            prepay_discount(state){
                return state.prepay_discount;
            },
            prepay_total_price(state){
                return state.prepay_total_price;
            },
            prepay_sales_tax(state){
                return state.prepay_sales_tax;
            },
            prepay_tax_percent(state){
                return state.prepay_tax_percent;
            },
            prepay_special_fee(state){
                return state.prepay_special_fee;
            },
            single_day_type(state){
                return state.single_day_type;
            },
            is_in_special_period(state){
                return state.is_in_special_period;
            },
            special_period_increase(state){
                return state.special_period_increase;
            },
            special_period_start_date(state){
                return state.special_period_start_date;
            },
            special_period_end_date(state){
                return state.special_period_end_date;
            },
            special_period_rate_type(state){
                return state.special_period_rate_type;
            },
            rechapcha_is_checked(state){
                return state.rechapcha_is_checked;
            },
            prepay_total_packages_price(state){
                return state.prepay_total_packages_price;
            }
        },
        mutations: {
            set_step_id(state, n) {
                state.currentStepId = n;
            },
            set_coupon_response(state, n) {
                state.coupon_response = n;
            },
            set_coupon_status(state, n) {
                state.coupon_status = n;
            },

            set_loading(state, n) {
                state.config.loading = n;
            },
            set_step_loading(state, n) {
                state.config.stepLoading = n;
            },
            set_return_customer_full_name(state, n) {
                state.return_customer_full_name = n;
            },
            set_return_customer_dob(state, n) {
                state.return_customer_dob = n;
            },
            set_model_value(state, {set, path, value}) {
                if (set) {
                    set(state, value);
                } else if (path)
                    _.set(state, path, value)

            },

            set_is_watched_rental_details(state, n) {
                state.is_watched_rental_details = n;
            },

            set_disabled_status(state, n){
                state.disabled_status = n;
            },
            set_book_me_host_code(state, n){
                state.book_me_host_code = n;
            },
            set_do_not_show_price_on_checkout(state, n){
                state.do_not_show_price_on_checkout = n;
            },
            set_skip_checkout(state, n){
                state.skip_checkout = n;
            },
            set_total_without_discount(state, n){
                state.total_without_discount = n;
            },
            set_prepay_discount(state, n){
                state.prepay_discount = n;
            },
            set_prepay_total_price(state, n){
                state.prepay_total_price = n;
            },
            set_prepay_sales_tax(state, n){
                state.prepay_sales_tax = n;
            },
            set_prepay_tax_percent(state, n){
                state.prepay_tax_percent = n;
            },
            set_prepay_special_fee(state, n){
                state.prepay_special_fee = n;
            },
            add_errors(state, {attr, scenario, errors}) {
                const errorsArr = state.validation.validators[scenario].errors[attr];
                if (!errorsArr) {
                    Vue.set(state.validation.validators[scenario].errors, attr, errors);
                } else {
                    state.validation.validators[scenario].errors[attr].push(...errors);
                }
            },
            remove_errors(state, {scenario}){
                state.validation.validators[scenario].errors = {};
            },

            set_kiosk_environment(state, env) {
                state.meta.environment = env;

                state.model.reservation.is_from_kiosk = env.includes('kiosk') ? 1 : 0;
                state.model.reservation.is_seasonal = env.includes('seasonal') ? 1 : 0;
                state.model.reservation.is_returned = env.includes('returned') ? 1 : 0;
                state.model.reservation.is_delivery = env.includes('delivery') ? 1 : 0;
            },

            set_step_success(state, {id, success}) {
                const stepObj = state.steps.find(s => s.id === id);
                stepObj.error = null;
                stepObj.success = success === undefined ? true : !!success;
            },
            set_step_error(state, {id, error}) {
                const stepObj = state.steps.find(s => s.id === id);
                stepObj.success = false;
                stepObj.error = error;
            },
            set_single_day_type(state, n) {
                state.single_day_type = n;
            },
            set_single_day_reservation(state, n) {
                state.model.reservation.single_day_type = n;
            },
            set_resource(state, payload) {
                state.resources[payload.name] = payload.value;
            },
            reset_resources(state, payload) {
                payload.forEach(r => {
                    state.resources[r] = null;
                })
            },
            set_is_special_period_date(state, n) {
                state.is_in_special_period = n;
            },
            set_special_period_increase(state, n) {
                state.special_period_increase = n;
            },
            set_special_period_start_date(state, n) {
                state.special_period_start_date = n;
            },
            set_special_period_end_date(state, n) {
                state.special_period_end_date = n;
            },
            set_special_period_rate_type(state, n) {
                state.special_period_rate_type = n;
            },
            setFocusInput(state, inputRef) {
                state.focusInput = inputRef;
            },
            set_rechapcha_is_checked(state, n) {
                state.rechapcha_is_checked = n;
            },
            set_prepay_total_packages_price(state, n){
                state.prepay_total_packages_price = n;
            },
            ...store.mutations

        },
        actions  : {
            async do_set_step_id({commit, state, dispatch}, n) {
                commit('set_step_id', n);
                await dispatch('do_save_meta_state');
            },

            async do_save_reservation({commit, state}) {
                commit('set_model_value',{path:'model.reservation.pickup_day',value:((parseInt(state.resources.config.pickup_day_before) || parseInt(state.resources.config.delivery)) && (!state.model.reservation.is_from_kiosk && !window.location.href.includes('seasonal')))? state.model.reservation.pickup_day : 'day_of'})
                if(state.resources.config.securitydeposit && state.resources.config.frontend_view_folder == 'frontend.highcountryskiandtennis'){
                    commit('set_model_value',{path:'model.reservation.deposit',value: 1})
                }
                const payload = {
                    ...state.model.reservation,
                    meta_state: {
                        step: state.currentStepId,
                    }
                }
                payload['pickup_day'] = (parseInt(state.resources.config.pickup_day_before) && !state.model.reservation.is_from_kiosk)? payload['pickup_day'] : 'day_of';

                const response = await webRequestWrap(axios.post('/reservations/vue/save_reservation', payload));

                commit('reservation_update', {id: response.data.id});
                commit('set_reservees_number');
            },

            async do_save_kiosk_reservation_dates({commit, state}) {
                const reservation = {
                    ...state.model.reservation,
                }
                await webRequestWrap(axios.post('/reservations/vue/save_kiosk_reservation_dates', {
                    date_pickup: reservation.date_pickup,
                    date_return: reservation.date_return,
                    coupon_id: reservation.coupon_id ?? '0',
                }));
            },

            async do_save_kiosk_reservation({commit, state}) {
                const payload = {
                    ...state.model.reservation,
                    ...state.model.payment,
                    meta_state: {
                        step: state.currentStepId,
                    },
                    address: state.model.reservation.address_primary,
                    amount: 0,
                    charge_customer: 0,
                    cc: state.model.payment.cc.replaceAll(' ', '')
                }
                const response = await webRequestWrap(axios.post('/reservations/vue/save_kiosk_reservation', payload));

                if(response.data.data.id){
                    commit('reservation_update', {id: response.data.data.id});
                    commit('set_reservees_number');
                    return true;
                }else{
                    return response.data.data.error;
                }
            },

            async do_save_kiosk_seasonal_reservation({commit, state}) {
                const payload = {
                    ...state.model.reservation,
                    ...state.model.payment,
                    meta_state: {
                        step: state.currentStepId,
                    },
                    address: state.model.reservation.address_primary,
                    amount: 0,
                    charge_customer: 0,
                    cc: state.model.payment.cc.replaceAll(' ', '')
                }
                const response = await webRequestWrap(axios.post('/reservations/vue/save_kiosk_seasonal_reservation', payload));

                if(response.data.data.id){
                    commit('reservation_update', {id: response.data.data.id});
                    commit('set_reservees_number');
                    return true;
                }else{
                    return response.data.data.error;
                }
            },

            async do_save_reservee({commit, state}) {
                const response = await axios.post('/reservations/vue/save_reservee', {
                    reservees      : state.model.reservees,
                    additional_info: state.model.reservation.additional_info,
                    reservation: state.model.reservation
                }).catch(error => {
                    return error.response;
                });
                commit('reservee_update', response.data.data);
                return response;
            },

            async do_save_meta_state({commit, state}) {
                const payload = {
                    meta_state: {step: state.currentStepId},
                    id        : state.model.reservation.id
                };
                try {
                    await axios.post('/reservations/vue/save_meta', payload);
                } catch (e) {
                    console.log(e);
                }
            },

            async do_calculate_cost({commit, state}) {
                const response = await axios.get('/reservations/vue/calculate/'+state.model.reservation.id);
                commit('cost_update', response.data.data);
            },
            async do_calculate_kiosk_cost({commit, state}) {
                const response = await axios.get('/reservations/vue/kiosk_calculate/'+state.model.reservation.id);
                commit('cost_update', response.data.data);
            },
            async do_save_renter_information_kiosk({commit, state}) {
                commit('set_disabled_status', true);
                commit('set_step_loading', true);
                const response = await axios.post('/reservations/vue/save_renter_information', {
                    ...state.model.reservation,
                    ...state.model.payment,
                    reservees:state.model.reservees,
                    cc: state.model.payment.cc.replaceAll(' ', '')
                });
                return response;
            },
            async do_save_seasonal_renter_information_kiosk({commit, state}) {
                const response = await axios.post('/reservations/vue/save_seasonal_renter_information', {
                    ...state.model.reservation,
                    ...state.model.payment,
                    reservees:state.model.reservees,
                    cc: state.model.payment.cc.replaceAll(' ', '')
                });
            },

            async do_checkout_kiosk({commit, state}) {
                commit('set_disabled_status', true);
                commit('set_step_loading', true);
                const response = await axios.post('/reservations/vue/checkout_kiosk', {
                    ...state.model.reservation,
                    ...state.model.payment,
                    reservees:state.model.reservees,
                    cc: state.model.payment.cc.replaceAll(' ', '')
                });
                if( response ){
                    commit('set_disabled_status', false);
                    commit('set_step_loading', false);
                }
            },
            async do_checkout({commit, state}) {
                commit('set_disabled_status', true);
                commit('set_step_loading', true);
                const response = await axios.post('/reservations/vue/checkout', {
                    ...state.model.reservation,
                    ...state.model.payment ?? [],
                    reservees:state.model.reservees,
                    cc: state.model.payment.cc.replaceAll(' ', '')
                }).catch(error => {
                    return error.response;
                });
                if( response ){
                    if(!response.data?.success){
                        commit('set_disabled_status', false);
                        commit('set_step_loading', false);
                    }
                }
                return response;
            },

            async do_pay_kiosk({commit, state}) {
                const response = await axios.post('/reservations/vue/pay_kiosk', {
                    ...state.model.payment,
                    cc: state.model.payment.cc.replaceAll(' ', ''),
                    reservation_id: state.model.reservation.id,
                    first_name: state.model.reservation.first_name,
                    last_name: state.model.reservation.last_name,
                    email: state.model.reservation.email,
                    is_seasonal: state.model.reservation.is_seasonal,
                }).catch(error => {
                    return error.response;
                });
                if( response ){
                    commit('set_disabled_status', false);
                    commit('set_step_loading', false);
                }
                return response.data;
            },

            async do_complete_reservation({commit, state}) {
                const response = await axios.post('/reservations/vue/complete_reservation', {});
                if(response.data.data.id){
                    return true;
                }else{
                    return response.data.data.error;
                }
            },



            async do_save_swipe_kiosk({ commit, state}) {
                commit('set_step_loading', true);
                const response = await axios.post('/reservations/vue/save_swipe_kiosk', {
                    ...state.model.payment,
                    cc: state.model.payment.cc.replaceAll(' ', ''),
                    is_seasonal: state.model.reservation.is_seasonal,
                    is_from_kiosk: state.model.reservation.is_from_kiosk,
                    reservation_id: state.model.reservation.id,
                    first_name: state.model.reservation.first_name,
                    last_name: state.model.reservation.last_name,
                    email: state.model.reservation.email
                }).catch(error => {
                    return error.response;
                });
                commit('set_step_loading', false);
                return response;
            },


            async do_load_all_resources({commit, state, dispatch}) {
                const remoteResources = Object.keys(state.resources)
                    .filter(k => (state.resources[k] || {}).__remote);
                await commit('reset_resources', remoteResources);

                const loadPromises = remoteResources.map(k => dispatch('load__' + k));
                await Promise.all(loadPromises);
                return true;
            },

            async do_apply_coupon({commit, state}) {
                if(state.model.reservation.coupon_id!==''){

                    const response = await axios.post('/apply_coupon', {
                        coupon : state.model.reservation.coupon_id,
                        reservation_start : state.model.reservation.date_pickup,
                        reservation_end : state.model.reservation.date_return,
                        is_seasonal: state.model.reservation.is_seasonal,
                    }).catch(error => {
                        return error.response;
                    });
                    if(response.status != 200){
                        state.model.reservation.coupon_id = '';
                    }
                    commit('set_coupon_response', response.data);
                    commit('set_coupon_status', response.status);
                }else{
                    commit('set_coupon_response', '');
                    commit('set_coupon_status', 200);
                }

            },

            async do_store_prepay_reservation({ commit, state}) {
                commit('set_disabled_status', true);
                commit('set_step_loading', true);
                const response = await axios.post('/reservations/vue/prepay', {
                    reservees      : state.model.reservees,
                    reservation    : state.model.reservation,
                    is_prepay: 1,
                    save_reservation: state.currentStepId == 2 ? true : false,
                }).catch(error => {
                    return error.response;
                });
                if(state.currentStepId == 1) {
                    commit('set_total_without_discount', response.data.prepayReservation.total_without_discount);
                    commit('set_prepay_discount', response.data.prepayReservation.discount);
                    commit('set_prepay_total_price', response.data.prepayReservation.total);
                    commit('set_prepay_sales_tax', response.data.prepayReservation.sales_tax);
                    commit('set_prepay_tax_percent', response.data.prepayReservation.tax_percent);
                    commit('set_prepay_special_fee', response.data.prepayReservation.special_fee);
                }
                if( response ){
                    if(state?.resources?.config?.prepay_payment !=0 || state?.resources?.config?.only_save_card_at_prepay !=0){
                        if(!state.rechapcha_is_checked && state.resources.config.google_recaptcha=="1" && state.resources.config.google_recaptcha_site_key!=''){
                            commit('set_disabled_status', true);
                        }else{
                            commit('set_disabled_status', false);
                        }
                    }else{
                        commit('set_disabled_status', false);
                    }
                    commit('set_step_loading', false);
                }
                return response;
            },

            async do_store_prepay_reservation_checkout({ commit, state}) {
                commit('set_disabled_status', true);
                commit('set_step_loading', true);
                const response = await axios.post('/reservations/vue/prepay/checkout_store', {
                    ...state.model.payment,
                    cc: state.model.payment.cc.replaceAll(' ', ''),
                    reservation               : state.model.reservation,
                    total_without_discount    : state.total_without_discount,
                    prepay_discount           : state.prepay_discount,
                    amount                    : state.prepay_total_price,
                    prepay_sales_tax          : state.prepay_sales_tax,
                    reservees      : state.model.reservees,
                    first_name: state.model.reservation.first_name,
                    last_name: state.model.reservation.last_name,
                    email: state.model.reservation.email,
                    is_prepay: 1,
                }).catch(error => {
                    return error.response;
                });
                if( response ){
                    commit('set_disabled_status', false);
                    commit('set_step_loading', false);
                }
                return response;
            },

            focusInput({ commit }, inputRef) {
                commit('setFocusInput', inputRef);
            },

            ...store.actions,
            ...normalResources.actions,

        },
        modules  : {
            ui: ui,
            validation: validation
        }
    };
}


export default prepareVuexConfig;
